import * as React from 'react';

/**
 * useSearch
 * @function useSearch - Custom hook for the search bar
 */
const useSearch = () => {
  const [isSearching, setIsSearching] = React.useState<boolean>(false);
  const [searchQuery, setSearchQuery] = React.useState<string>('');

  const updateSearchQuery = (value: string) => {
    setSearchQuery(value);
    if (!value) {
      setIsSearching(false);
    }
    if (value) {
      setIsSearching(true);
    }
  };

  return {
    searchQuery,
    updateSearchQuery,
    isSearching,
    setIsSearching
  };
};

export default useSearch;
